import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackVoteRequest = (requestId, voteType) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    request_id: requestId,
    vote_type: voteType,
    ...getEnvironmentData()
  };

  posthog.capture('vote_request', eventData);
  track('vote_request', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('AddToWishlist', {
      content_name: 'request_vote',
      content_type: 'product',
      content_id: requestId
    });
  }
}; 